import { hideManagerOverlay, withOverlayLoader } from '../helpers.js';
import { beginNavigation, getNavigationSequence, isStaleNavigation, onNavigationInvalidated } from './router.js';
import { showTopLoadingBar, hideTopLoadingBar } from './top-loading-bar.js';
import { forceCleanupBootstrapModals } from './bootstrap-modal-cleanup.js';
import { getKioskConfig } from './kiosk-config.js';

const PC_MIN_WIDTH_MQ = '(min-width: 768px)';

function shouldUseTopLoadingBar() {
    if (getKioskConfig().kioskValidated) {
        return false;
    }
    return window.matchMedia(PC_MIN_WIDTH_MQ).matches;
}

let activeXhr = null;

onNavigationInvalidated(function () {
    if (activeXhr && typeof activeXhr.abort === 'function') {
        activeXhr.abort();
    }
    activeXhr = null;
    hideTopLoadingBar();
    hideManagerOverlay();
    forceCleanupBootstrapModals();
});

function guardAjaxOptions(ajaxOptions, token) {
    const userSuccess = ajaxOptions.success;
    const userError = ajaxOptions.error;
    const dispatchedPathname = window.location.pathname;
    return Object.assign({}, ajaxOptions, {
        success: function (data, textStatus, jqXHR) {
            if (isStaleNavigation(token) && window.location.pathname !== dispatchedPathname) {
                console.warn('guardAjaxOptions: dropped stale success', {
                    token: token,
                    navigationSequence: getNavigationSequence(),
                    url: ajaxOptions.url,
                    stack: new Error().stack,
                });
                return;
            }
            if (userSuccess) {
                userSuccess(data, textStatus, jqXHR);
            }
        },
        error: function (jqXHR, textStatus, errorThrown) {
            if (textStatus === 'abort') {
                return;
            }
            if (userError) {
                userError(jqXHR, textStatus, errorThrown);
            }
        }
    });
}

export function navigateWithOverlay(ajaxOptions) {
    const token = beginNavigation();
    const loader = withOverlayLoader(guardAjaxOptions(ajaxOptions, token));
    activeXhr = loader && loader.xhr ? loader.xhr : loader;
    return loader;
}

function withTopBarLoader(ajaxOpts, token) {
    if (!window.jQuery) return null;
    const $ = window.jQuery;
    const deferHide = !!ajaxOpts.deferHide;

    function hideNow() {
        if (isStaleNavigation(token)) {
            return;
        }
        hideTopLoadingBar();
    }

    function finishBar() {
        if (!deferHide) hideNow();
    }

    showTopLoadingBar();

    const originalSuccess = ajaxOpts.success;
    const originalError = ajaxOpts.error;

    const xhr = $.ajax({
        ...ajaxOpts,
        deferHide: undefined,
        forceTopBar: undefined,
        success: function (...args) {
            if (typeof originalSuccess === 'function') originalSuccess.apply(this, args);
            finishBar();
        },
        error: function (...args) {
            finishBar();
            if (typeof originalError === 'function') originalError.apply(this, args);
        }
    });

    return deferHide ? { xhr, hide: hideNow } : xhr;
}

export function navigateWithTopBar(ajaxOptions) {
    const forceTopBar = ajaxOptions.forceTopBar === true;
    const opts = Object.assign({}, ajaxOptions);
    delete opts.forceTopBar;
    if (!forceTopBar && !shouldUseTopLoadingBar()) {
        return navigateWithOverlay(opts);
    }
    const token = beginNavigation();
    const loader = withTopBarLoader(guardAjaxOptions(opts, token), token);
    activeXhr = loader && loader.xhr ? loader.xhr : loader;
    return loader;
}

export function navigateAjax(ajaxOptions) {
    const $ = window.jQuery;
    const token = beginNavigation();
    const dispatchedPathname = window.location.pathname;
    const xhr = $.ajax(guardAjaxOptions(ajaxOptions, token));
    activeXhr = xhr;
    return xhr.then(function (data) {
        const stillStale = isStaleNavigation(token) && window.location.pathname !== dispatchedPathname;
        return stillStale ? $.Deferred().reject().promise() : data;
    });
}
